import React from 'react';
import { Collapsible } from '../../components';

import { steps } from '../constants';
import { LookbookTopButtons } from '../atoms';
import { Highlight } from '../molecules';
import { useUpsertLookbook } from '../useUpsertLookbook';

export function Highlights() {
  const {
    getCollapsibleState,
    toggleCollapsible,
    getHighlightsCount,
    goToCover,
    highlights,
    setHighlights,
    highlightErrors,
    setHighlightErrors,
  } = useUpsertLookbook();
  const { isOpen, isVisible } = getCollapsibleState(steps.HIGHLIGHTS);

  if (!isVisible) {
    return null;
  }

  const highlightsCount = getHighlightsCount();

  return (
    <Collapsible
      trigger="Highlights"
      handleTriggerClick={() => toggleCollapsible(steps.HIGHLIGHTS)}
      open={isOpen}
      testId="lookbook-highlights"
      noContainer
    >
      <div className="highlights-page">
        {/* `getHighlightsCount()` is ceil(listings / 12), capped at 3 — so with
            no listings it is 0 and this section rendered nothing but its Next
            button. Say why instead of showing an empty panel. */}
        {highlightsCount === 0 && (
          <div className="lb-empty">
            <p className="lb-empty__title">No highlights available yet</p>
            <p className="lb-empty__body">
              Highlights unlock with the products in this lookbook — one per 12
              listings, up to three. Add listings in{" "}
              <strong>Select Listings</strong> to enable them.
            </p>
          </div>
        )}

        {Array.from({ length: highlightsCount }).map((_, idx) => (
          <Highlight
            key={idx}
            {...{
              idx,
              highlights,
              setHighlights,
              highlightErrors,
              setHighlightErrors,
            }}
          />
        ))}

        <div className="row">
          <div className="col-12 pr-20">
            <LookbookTopButtons className="products-next text-right" onNext={goToCover} />
          </div>
        </div>
      </div>
    </Collapsible>
  );
}
